import React, { Component } from "react"
import request from "superagent"
import { Formik, Field, Form } from "formik"
import fieldStatus from "helpers/fieldStatus"
import NumberField from "components/NumberField"
import * as Yup from "yup"
import submitData from "helpers/submitData"
import settings from "settings"
import { connect } from "react-redux"
import DateField from "components/DateField"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"
import ReactSelect from "components/ReactSelect"
import axios from "axios"
import HTMLEditor from "components/HTMLEditor"
import { toast } from "react-toastify"
import _ from "lodash"

class EditHomeInfo extends Component {
	constructor(props) {
		super(props)
		this.state = {
			data: {
				address: "",
			},
			fields: {
				beds: null,
				full_baths: null,
				half_baths: null,
				garage: null,
				sqft: null,
				stories: null
			},
			image_type: null,
		}
	}

	componentDidMount() {
		var userToken = localStorage.getItem("user")
		axios
			.post(settings.ep + "/getLotFull", this.props.data, {
				headers: { Authorization: `Bearer ${userToken}` },
			})
			.then((response) => {
				let pick = _.pick(response.data.lot, ['beds', 'full_baths', 'half_baths', 'garage', 'sqft', 'stories'])
				this.setState({ fields: pick }, () => {
					console.log(this.state)
				})
				this.props.loadingStatus(false)
			})
			.catch((error) => {
				// need error handling
				this.props.loadingStatus(false)
			})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	formLayout = (f) => {
		return (
			<div>
				{console.log(f)}
				<Form>
					<ul className="modalForm__list">
						<li className={fieldStatus("sqft", f)}>
							<label htmlFor="sqft">
								Square Feet<sup>*</sup>
							</label>
							{f.errors.sqft && f.touched.sqft && <div className="form__message">{f.errors.sqft}</div>}
							<NumberField
								name="sqft"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.sqft}
								error={f.errors.sqft}
								value={f.values.sqft}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("stories", f)}>
							<label htmlFor="stories">
								Stories<sup>*</sup>
							</label>
							{f.errors.stories && f.touched.stories && (
								<div className="form__message">{f.errors.stories}</div>
							)}
							<NumberField
								name="stories"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.stories}
								error={f.errors.stories}
								value={f.values.stories}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("beds", f)}>
							<label htmlFor="beds">
								Beds<sup>*</sup>
							</label>
							{f.errors.beds && f.touched.beds && <div className="form__message">{f.errors.beds}</div>}
							<NumberField
								name="beds"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.beds}
								error={f.errors.beds}
								value={f.values.beds}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("full_baths", f)}>
							<label htmlFor="full_baths">
								Full Baths<sup>*</sup>
							</label>
							{f.errors.full_baths && f.touched.full_baths && (
								<div className="form__message">{f.errors.full_baths}</div>
							)}
							<NumberField
								name="full_baths"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.full_baths}
								error={f.errors.full_baths}
								value={f.values.full_baths}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("half_baths", f)}>
							<label htmlFor="half_baths">
								Half Baths<sup>*</sup>
							</label>
							{f.errors.half_baths && f.touched.half_baths && (
								<div className="form__message">{f.errors.half_baths}</div>
							)}
							<NumberField
								name="half_baths"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.half_baths}
								error={f.errors.half_baths}
								value={f.values.half_baths}
								thousandSeparator={true}
							/>
						</li>
						<li className={fieldStatus("garage", f)}>
							<label htmlFor="garage">
								Garage<sup>*</sup>
							</label>
							{f.errors.garage && f.touched.garage && (
								<div className="form__message">{f.errors.garage}</div>
							)}
							<NumberField
								name="garage"
								type="text"
								className="form__input"
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.garage}
								error={f.errors.garage}
								value={f.values.garage}
								thousandSeparator={true}
							/>
						</li>
					</ul>
					<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
				</Form>
			</div>
		)
	}

	render() {
		return (
			<div className="modal">
				<h3>Edit Home Info: {this.props.data.address}</h3>
				<Formik
					initialValues={this.state.fields}
					enableReinitialize
					onSubmit={(values) => {
						values.id = this.props.data.id
						values.action = "inputBuildersHomeInfo"
						//delete values.images
						submitData("mainIngest", values)
							.then((data) => {
								this.props.notify(data, this.props.name)
							})
							.catch((e) => {
								this.props.notify(e, this.props.name)
							})
					}}
					render={(f) => this.formLayout(f)}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(EditHomeInfo)
